import React from 'react';
import { useSelector } from 'react-redux';

function useLoadingState() {
  const loadStatus = useSelector((state) => state.loadStatus);
  return loadStatus;
}

export default useLoadingState;
